module.exports = __webpack_public_path__ + "img/1_uk.aa5d2b73.svg";